import { AEMOptions } from "@AEM/models/AEMPage.model"
import { AEMPageType } from "@AEM/models/AEMPage.model"
import { UseQueryResult } from "@tanstack/react-query"
import { useAEMContent } from "./useAEMContent"
import { createItemsArrayMapper } from "@AEM/AEMContentMapper"
import { AEMLanguageItem } from "@AEM/models/AEMResponse.model"

export const useAEMLanguageData = (options?: AEMOptions) => {
	const { data, isLoading, error, refetch } = useAEMContent(
		AEMPageType.LANGUAGES,
		{ ...options, mapper: createItemsArrayMapper() }
	) as UseQueryResult<AEMLanguageItem[]>

	const languageData = data

	return { languageData, isLoading, error, refetch }
}
